import Snowfall from "react-snowfall";
import { Fragment } from "react";

const Socials = () => {
  return (
    <Fragment>
      <Snowfall color="#a855f7" wind={[-0.5, 0.5]} speed={[0.3, 1]} />
      <div className="w-full h-full flex flex-wrap items-center justify-evenly md:flex-nowrap pb-16 md:pb-0">
        <div className="py-4 px-8 bg-slate-300 shadow-lg rounded-lg">
          <div>
            <img src={process.env.PUBLIC_URL + "/images/linkedin.png"} alt="linkedin" />
          </div>
          <div>
            <p className="mt-2 text-gray-600"></p>
          </div>
          <div className="flex justify-center mt-4">
            <a
              href="https://www.linkedin.com/in/abdellah-oumas/"
              target="_blank"
              rel="noreferrer"
              className="text-xl rounded-full px-4 py-1 font-normal text-blue-700 border-2 border-blue-700 hover:bg-slate-200"
            >
              View profile
            </a>
          </div>
        </div>
        <div className="py-4 px-8 bg-slate-300 shadow-lg rounded-lg">
          <div className="flex justify-center">
            <img src={process.env.PUBLIC_URL + "/images/twitter.png"} alt="twitter" />
          </div>
          <div>
            <p className="mt-2 text-gray-600"></p>
          </div>
          <div className="flex justify-center mt-4">
            <a
              href="https://twitter.com/intent/tweet?screen_name=Clerxam&ref_src=twsrc%5Etfw"
              className="text-xl rounded-full px-4 py-1 font-normal text-blue-700 border-2 border-blue-700 hover:bg-slate-200"
            >
              Tweet
            </a>
          </div>
        </div>
        <div className="py-4 px-8 bg-slate-300 shadow-lg rounded-lg">
          <div>
            <img src={process.env.PUBLIC_URL + "/images/facebook.png"} alt="facebook" />
          </div>
          <div>
            <p className="mt-2 text-gray-600"></p>
          </div>
          <div className="flex justify-center mt-4">
            <a
              href="https://www.facebook.com/abdellah.oumas/"
              target="_blank"
              rel="noreferrer"
              className="text-xl rounded-full px-4 py-1 font-normal text-sky-800 border-2 border-sky-800 hover:bg-slate-200"
            >
              Inactive
            </a>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Socials;
